import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { ObjectF } from '../../../models/formulas/object';
import { findObjectCatalogAct, saveObjectCatalogAct, updateObjectCatalogAct } from '../../../store/object-catalog/object-catalog.action';

@Component({
  selector: 'app-object-add',
  standalone: false,
  templateUrl: './object-add.component.html',
  styleUrl: './object-add.component.css'
})
export class ObjectAddComponent {

  objectCatForm!: NgForm;
  loading = false;
  title!: string;
  object: ObjectF = new ObjectF();
  violations: any = {};

  constructor(
    private route: ActivatedRoute,
    private objectStore: Store<{objectCatalogRdc: any}>
  ) {
    this.objectStore.pipe(
      select('objectCatalogRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        object: state.object,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ object, violations, loading }) => {
      this.object = JSON.parse(JSON.stringify(object));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Benefico';

      if(this.objectCatForm){
      
        Object.keys(this.objectCatForm.controls).forEach(controlName => {
          const control = this.objectCatForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.objectStore.dispatch(findObjectCatalogAct({ id }));
      }else{
        this.object = new ObjectF();
        this.object.active = true;
        this.loading = false;
        this.title = 'Agregar Beneficio';
      }
    });

    //this.catalogOfferStore.dispatch(findObjectTypeCatalogAct());
  }

  onSubmitBenefir(objectCatForm: NgForm): void {
    //this.loading = true;
    this.objectCatForm = objectCatForm;
    const objectCopy = JSON.parse(JSON.stringify(this.object));
   
    if (objectCopy.id > 0) {
      this.objectStore.dispatch(updateObjectCatalogAct({ objectUpdated: objectCopy }))
    } else {
      this.objectStore.dispatch(saveObjectCatalogAct({ objectNew: objectCopy }))
    }
  }

  compareObjectTypes = (a: any, b: any) => a?.id === b?.id;
  removeSpaces() {
    this.object.code = (this.object.code ?? '').replace(/\s+/g, '');
  }  
  
}
